import { CdkDrag, CdkDropList } from "@angular/cdk/drag-drop";
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslocoDirective } from "@jsverse/transloco";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { AutocompleteLibModule } from "angular-ng-autocomplete";
import { NgScrollbarModule } from 'ngx-scrollbar';
import { CoreCommonModule } from "../../../../../@core/common.module";
import { SharedModule } from "../shared.module";
import { CategoryNameComponent } from './components/category-name/category-name.component';
import { CategoryValueComponent } from './components/category-value/category-value.component';
import { CustomColumnsSettingsComponent } from './components/custom-columns-settings/custom-columns-settings.component';
import { DateColumnComponent } from './components/date-column/date-column.component';
import { DictionaryColumnComponent } from "./components/dictionary-column/dictionary-column.component";
import { SimpleTableCellComponent } from "./components/simple-table-cell/simple-table-cell.component";
import { TableComponent } from './components/table/table.component';
import { TooltipOnTextOverflowComponent } from './components/tooltip-on-text-overflow/tooltip-on-text-overflow.component';
import { MomentPipe } from "app/pipes/moment.pipe";


@NgModule({
    declarations: [
        TableComponent,
        SimpleTableCellComponent ,
        DateColumnComponent,
        CategoryNameComponent,
        CategoryValueComponent,
        DictionaryColumnComponent,
        CustomColumnsSettingsComponent,
        TooltipOnTextOverflowComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        CoreCommonModule,
        NgScrollbarModule,
        NgbModule,
        AutocompleteLibModule,
        CdkDrag,
        CdkDropList,
        TranslocoDirective,
        MomentPipe
    ],
    exports: [TableComponent]
})
export class TableModule {
}
